import type { Variable } from "../types";
import type { VariableType } from "../calculated-field/CalculatedFieldOperation/types";

export type DataCenterSource = "sdt" | "Orquestador" | "Operador";

export type ActionItemType = "read" | "create" | "update" | "delete";

export type ValueInputType =
  | "string"
  | "number"
  | "date"
  | "boolean"
  | "variable"
  | "regex"
  | "positive-integer";

/**
 * Maps ValueInputType to VariableType for filtering variables by type
 */
export const mapValueInputTypeToVariableType = (
  valueInputType: ValueInputType,
): VariableType => {
  switch (valueInputType) {
    case "string":
    case "regex":
      return "string";
    case "number":
    case "positive-integer":
      return "number";
    case "date":
      return "date";
    case "boolean":
      return "boolean";
    case "variable":
      return "string"; // fallback to string for generic variable type
    default:
      return "string"; // fallback
  }
};

/**
 * Maps VariableType to ValueInputType, with fallback for unsupported types
 */
export const mapVariableTypeToValueInputType = (
  variableType: VariableType | undefined,
): ValueInputType => {
  switch (variableType) {
    case "string":
      return "string";
    case "number":
      return "number";
    case "float":
      return "number"; // Map float to number
    case "date":
      return "date";
    case "boolean":
      return "boolean";
    case "array":
    case "file":
    case "select":
    case "":
    default:
      return "string"; // fallback for unsupported types
  }
};

export interface ValueColumn {
  label: string;
  isRequired: boolean;
  name: string;
  placeholder: string;
  valueType: ValueInputType;
  value: string | Variable;
  inputType: "input" | "variable";
}

//TODO: merge with if
export type ConditionEnum =
  | "EXIST"
  | "NOT_EXIST"
  | "IS_EMPTY"
  | "IS_NOT_EMPTY"
  | "EQUALS"
  | "NOT_EQUALS"
  | "CONTAINS"
  | "NOT_CONTAINS"
  | "STARTS_WITH"
  | "ENDS_WITH"
  | "MATCHES"
  | "NOT_MATCHES"
  | "GREATER_THAN"
  | "LESS_THAN"
  | "GREATER_THAN_OR_EQUAL"
  | "LESS_THAN_OR_EQUAL"
  | "IS_AFTER"
  | "IS_BEFORE"
  | "IS_IN_OR_AFTER"
  | "IS_IN_OR_BEFORE"
  | "IS_TRUE"
  | "IS_FALSE"
  | "LENGTH_EQUAL"
  | "LENGTH_NOT_EQUAL"
  | "LENGTH_GREATER_THAN"
  | "LENGTH_LESS_THAN"
  | "LENGTH_GREATER_THAN_OR_EQUAL"
  | "LENGTH_LESS_THAN_OR_EQUAL"
  | "NOT_STARTS_WITH"
  | "NOT_ENDS_WITH"
  | "BETWEEN"
  | "ANY"
  | "AFTER"
  | "BEFORE"
  | "AFTER_EQUALS"
  | "BEFORE_EQUALS";

export interface DCOperation {
  name: ConditionEnum;
  label: string;
  type?: ValueInputType;
  needsComparativeValue?: boolean;
  needsComparativeRange?: boolean;
  comparativeValueType?:
    | "string"
    | "number"
    | "regex"
    | "date"
    | "variable"
    | "boolean"
    | "positive-integer";
}
